const getters = {
  // sidebar: state => state.app.sidebar,
  // size: state => state.app.size,
  // device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  visitedViewsList: state => state.tabView.visitedViewsList,
  // cachedViews: state => state.tagsView.cachedViews,
  // token: state => state.user.token,
  // avatar: state => state.user.avatar,
  // name: state => state.user.name,
  // introduction: state => state.user.introduction,
  // roles: state => state.user.roles,
  // permissions: state => state.user.permissions,
  // permission_routes: state => state.permission.routes
}
export default getters



// WEBPACK FOOTER //
// ./src/store/modules/getters.js